import SortDesc from './SortDesc'

export default SortDesc
// eslint-disable-next-line import/export
export * from './SortDesc'
